import React from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";

const NoAccessPage = () => {
  const [sidebarOpen, setSidebarOpen] = React.useState(() => (typeof window !== "undefined" ? window.innerWidth >= 1024 : true));
  const toggleSidebar = () => setSidebarOpen((prev) => !prev);
  return (
    <div className="flex flex-col min-h-screen">
      <Header toggleSidebar={toggleSidebar} sidebarOpen={sidebarOpen} />
      <div className="flex flex-1 bg-gray-100 min-w-0 max-w-full overflow-x-hidden">
        <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
        <div className={`flex-1 min-w-0 max-w-full overflow-x-hidden flex items-center justify-center p-3 sm:p-6 transition-all duration-300 ${sidebarOpen ? "lg:ml-64" : "lg:ml-20"} ml-0`}>
          <div className="bg-white p-10 rounded-xl shadow-lg text-center max-w-md w-full">
            <h2 className="text-2xl font-bold text-red-600 mb-4">You do not have access</h2>
            <p className="text-gray-700 mb-6">Please contact the administrator to get access to this page.</p>
            <button
              onClick={() => window.history.back()}
              className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors"
            >
              Go Back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoAccessPage;
